import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme: any) => ({
  backButton: {
    marginRight: 2,
    padding: 0,
    cursor: "pointer",
    border: "2px solid transparent",
    color: "black",
    "&:hover": {
      opacity: 0.7,
    },
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 10,
    paddingBottom: "10px",
  },
  box: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
  },
  boxText: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
    color: "#272525",
    display: "flex",
    alignItems: "center",
  },
  boxTextBack: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
  },

  labelActionStyle: {
    color: "#4d1277",
    backgroundColor: "#4d127733",
    border: "none",
    fontWeight: 400,
    fontSize: "14px",
    height: 30,
    borderRadius: "5px",
    px: 1.2,
    "& .MuiChip-icon": {
      color: "#4d1277",
    },
  },
  root: {
    paddingBottom: "40px",
    overflowY: "auto",
    paddingRight: "10px",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#4d127733",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    height: "calc(100vh - 170px)",
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 190px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 200px)",
    },
  },
  labelContainer: {
    height: "auto",
  },
}));
export default useStyles;
